import { useForm } from "react-hook-form";
import { useLogin } from "./hooks";
import "./LoginPage.css";
import { useNavigate } from "react-router";
import logo from "../../assets/images/logo.png";


function LoginPage() {
  const { register, handleSubmit } = useForm();
  const navigate = useNavigate();
  const loginMutation = useLogin({
    onSuccess:()=>{
      navigate("/dashboard/news")
    }
  });
  

  const onSubmit = (data) => {
    loginMutation.mutate(data);
  };

  return (
    <div className="form-container">
      <form onSubmit={handleSubmit(onSubmit)}>
        <picture>
          <img src={logo} alt="" srcset="" />
        </picture>
        <input {...register("email")} placeholder="Email" required />
        <input
          {...register("password")}
          type="password"
          placeholder="Password"
          required
        />

        <button type="submit">
          {loginMutation.isPending ? "Loading..." : "Login"}
        </button>

        {loginMutation.isError && (
          <p className="login-error-message">Invalid credentials</p>
        )}
      </form>
    </div>
  );
}

export default LoginPage;
